import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button, Select, MenuItem} from '@material-ui/core';
import {Stack, Snackbar, Alert, LinearProgress} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import AutocompleteTreeviewTemp from '../components/AutocompleteTreeviewTemp';
import Cookies from 'js-cookie';
import axios from 'axios';
import TreeViewTopics from './TreeViewTopics';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [pageLoading, setPageLoading] = React.useState(true);
  const [saveLoading, setSaveLoading] = React.useState(false);
  
  const [topicTemplateList, setTopicTemplateList] = React.useState([]);
  const [treeTopicObj, setTreeTopicObj] = React.useState({});
  const [treeview, setTreeview] = React.useState([]);
  const [templateId, setTemplateId] = React.useState(0);
  const [templateTitle, setTemplateTitle] = React.useState('');
  
  ///const [sequence, setSequence] = React.useState(1);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {
    setSaveLoading(false);
    setTreeTopicObj({});    	
    if(open && props.dataObj && props.dataObj.id){	
      getApiData();    
    }

	}, [props.dataObj,open]);

  async function getApiData(){
		///alert(userObj.token);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 			
			axios.get(env.API_URL+"/topic-service/read/topics-templates?sortby=templateName", axiosHeader) 
			   .then(response => {
				  setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){
					setTopicTemplateList(response.data.obj.list);
				}		
			})
	}

  function getLoadTree(obj){
    if(obj){      
      setTemplateId(obj.autoId);
      setTemplateTitle(obj.templateName);
      let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'loginId': userObj.loginId,
          'token': userObj.token,
          'device': 'web'					
        }
      }; 			
      axios.get(env.API_URL+"/topic-service/read/topics-templates-treeview?templateId="+obj.autoId, axiosHeader) 
        .then(response => {
          setPageLoading(false); 
        if(response.data && response.data.responseTxt==="invalidToken"){ 
          Cookies.remove('isadminloggedin');
          window.location.href='login';
        }else if(response.data && response.data.responseTxt==="success"){
          setTreeview(response.data.obj.list);
        }else{
          setTreeview([]);
        }		
      })

    }else{
      setTemplateId(0);
      setTemplateTitle('');
      setTreeview([]);
    }  

  }

	function saveData(){    
    
		if(treeTopicObj && treeTopicObj.topicId>0){ 
      setSaveLoading(true);

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'	
				}
			}; 
      
			const data = new FormData();
      data.append('templateId', props.dataObj.templateId);
      data.append('copyToId', props.dataObj.id);
      data.append('copyFromId', treeTopicObj.id); 

      let apiURL='/topic-service/import/topics-templates-treeview';
      let myMessage="Tree has been copied.";
             
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSaveLoading(false);
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.tempTreeview(response.data.obj.list);
          ///window.location.reload();	
					return false;
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Tree could not be copied.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("ERROR: ", error);
			})	
		}		
	}
  
  function selectTreeTopic(obj) {
    if(obj && obj.topicId>0){
      setTreeTopicObj(obj);
    }   
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}>{(treeTopicObj && treeTopicObj.topicId>0)?<>Selected Topic: {treeTopicObj.title}</>:<>Select Topic</>}</DialogTitle>
          <DialogContent style={{minHeight:170}} >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <p>
                  {pageLoading?<LinearProgress />:null}
                  <div>
                      {(topicTemplateList && topicTemplateList.length>0)?  
                        <AutocompleteTreeviewTemp options={topicTemplateList} defaultValue={templateTitle} handleSelect={getLoadTree} />
                      :<Select 
                         fullWidth
                         labelId="select-class-label"
                         id="select-class"
                         variant="standard"
                         >
                          <MenuItem></MenuItem>
                      </Select>}                            
                </div>
                  <div style={{marginTop:10,marginLeft:-32}}>
                    {(treeview && treeview.length>0)?<TreeViewTopics treeViewData={treeview} selectTreeTopic={selectTreeTopic} />:null}
                  </div>

                      <Box mt={2}>
                          {/* <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button> */}
					    	          {saveLoading?
                          <LoadingButton loading={saveLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Wait...</LoadingButton>
					    	          :(treeTopicObj && treeTopicObj.topicId>0)?
                          <Button onClick={() => {saveData()}} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Done</Button>
                          :null}
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;